import {ProcessElementProps} from "./ProcessElementProps.js";
import {ProcessElement} from "./ProcessElement.js";
import {NODE_REGISTRY} from "./NodeRegistry.js";

export class ProcessNodeProps extends ProcessElementProps {
	constructor(processEditor, fieldPath, obj, member) {
		super(processEditor, fieldPath, obj, member);
	}

	getTypeEditors() {
		const eds =  super.getTypeEditors();
		NODE_REGISTRY.forEach((value, key)=> {
			/** @type {SwitchType} */
			const ed = {};
			ed.name = value.name;
			ed.class = key;
			ed.editorConstructor = ProcessElement.editorFor(key);
			eds.push(ed);
		});
		return eds;
	}

	rebuild() {
		super.rebuild();
	}

	onChange(field, newValue) {
		if (field === (this.field + ".class")) {
			// Type change
			this.processEditor.nodeTypeChanged(this.data);
		} else return super.onChange(field, newValue);
	}
}
